module.exports = "<h4>Browser not supported.</h4>\n<p>Your browser is currently not supported. Please upgrade to the latest version and try again.</p>"